/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';

import { Input, Form } from 'antd';

const TransactionCreateRefundForm = ({
  form, selectedTransaction, kitegatewayReference,
}) => (
  <Form
    name="basic"
    className="gx-form-row0"
    ref={form}
    initialValues={{
      transaction_status: selectedTransaction.transaction_status,
    }}
  >
    <div>Refund</div>
    <Form.Item
      name="amount"
      initialValue={selectedTransaction.transaction_amount}
    >
      <Input />
    </Form.Item>

    <Form.Item
      name="kitegateway_reference"
      initialValue={kitegatewayReference}
    >
      <Input readOnly />
    </Form.Item>
  </Form>
);

TransactionCreateRefundForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  selectedTransaction: PropTypes.oneOfType([
    PropTypes.object,
  ]).isRequired,
  kitegatewayReference: PropTypes.string,
};

TransactionCreateRefundForm.defaultProps = {
  form: {},
  kitegatewayReference: '',
};

export default TransactionCreateRefundForm;
